import React from 'react';
import Countdown from '../../../../components/Countdown/Countdown';
import { useStateContext } from '../../../../context/ContextProvider';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';
import Footer from '../../../../components/Footer/Footer';
import NoiseBackground from '../../../../components/Background/NoiseBackground';
import HikalLeadFormLuxury from '../../../../components/LeadForm/HikalLeadFormLuxury';

function DamacTownhouseHikal({
    language
}) {
    const {
        langs,
        langCode,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const poster = "/assets/images/projects/damac-townhouse/1.webp";
    const webm = "/assets/images/projects/damac-townhouse/hero.webm";
    const mp4 = "/assets/images/projects/damac-townhouse/hero.mp4";

    return (
        <>
            <div>
                <NoiseBackground />

                {/* LANGUAGE */}
                <LanguageNavigate
                    support={["en", "ar"]}
                    redirect={{
                        en: "/projects/damac/townhouse",
                        ar: "/projects/damac/townhouse/ar"
                    }}
                />

                {/* IMAGES */}
                <div className="fixed top-0 left-0 w-full flex justify-center -z-1 lg:hidden" style={{ zIndex: 0 }}>
                    <video
                        autoPlay={true}
                        loop={true}
                        muted={true}
                        playsInline={true}
                        preload="auto"
                        poster={poster}
                        width="350"
                        height="350"
                        className={`w-full md:max-w-[550px]`}
                    >
                        <source src={webm} type="video/webm" />
                        <source src={mp4} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:px-[7%]">
                    <div className="h-full w-full items-center justify-center hidden lg:flex">
                        <video
                            autoPlay={true}
                            loop={true}
                            muted={true}
                            playsInline={true}
                            preload="auto"
                            poster={poster}
                            width="350"
                            height="350"
                            className={`w-full md:max-w-[550px] rounded-sm`}
                        >
                            <source src={webm} type="video/webm" />
                            <source src={mp4} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className="relative px-[7%] lg:px-0 text-center my-5 py-5 z-1 flex flex-col gap-10 items-center" style={{ zIndex: 1 }}>
                        <div className="h-[300px] md:h-[400px] lg:h-0"></div>
                        <div className="luxury-card flex flex-col gap-10 py-6">
                            <div className="px-2">
                                {language === "ar"
                                    ? (
                                        <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                            {/* امتلك بيتك الفاخر في الداون تاون – فلل وتاون هاوس من داماك بـ 4 لـ 7 غرف نوم. */}
                                            امتلك منزلك الفاخر في قلب دبي، فلل ومنازل تاون هاوس من داماك، بتصاميم تتراوح بين 4 و7 غرف نوم.
                                            {/* <span className="text-2xl bounce-text secondary-text">
                                                6
                                            </span> */}
                                        </h1>
                                    ) : (
                                        <>
                                            <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl">
                                                Own Your Luxury Home in the heart of Dubai
                                                {/* <span className="text-2xl bounce-text secondary-text">
                                                    Downtown
                                                </span> */}
                                                – Exclusive 4–7 BHK Villas & Townhouses by DAMAC.
                                            </h1>
                                        </>
                                    )
                                }
                            </div>

                            {/* LIMITED TIME OFFER */}
                            <div className="w-full px-4">
                                <div className="padding-container flex items-center justify-center">
                                    <Countdown addClass={"-luxury"} />
                                </div>
                            </div>

                            {/* LEAD FORM */}
                            <div className="w-full px-4">
                                <HikalLeadFormLuxury
                                    developer="Damac"
                                    project="Townhouse"
                                    leadType={[{ "Townhouse": ["4 Bedrooms", "5 Bedrooms"], "Villa": ["5 Bedrooms", "6 Bedrooms", "7 Bedrooms"] }]}
                                    language={language === "ar" ? "Arabic" : "English"}
                                    enquiries={["4 Bedrooms", "5 Bedrooms", "6 Bedrooms", "7 Bedrooms"]}
                                    askEmail={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <Footer />
        </>
    );
}

export default DamacTownhouseHikal;
